
export function storeAccessToken(value)
{
    return {type:'gettoken', payload:value}
}
export function storeUserDetails(value){
    return {type:'getuser', payload:value}
}

export function storeIdTokenClaims(value){
    return {type:'STORE_ID_CLAIMS', payload:value}
}
export function updateCareFacility(value)
{
    return {type:'UPDATE_FACILTY_DETAILS', payload:value}
}
export function updateCareFacilityList(value)
{
    return {type:'UPDATE_CARE_FACILTY_LIST', payload:value}
}
export function updateActiveCounts(value)
{
    return {type:'UPDATE_ACTIVE_COUNTS', payload:value}
}
export function storeUserRole(value)
{
    return {type:'UPDATE_USER_ROLE', payload:value}
}

// export function storeManagementToken(value)
// {
//     return {type:'STORE_MGT_TOKEN', payload:value}
// }